<template>
  <div class="foro-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.push({ name: 'Foro' })">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">Foro Estudiantil</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Únete a las discusiones de tu comunidad académica</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30 d-none d-sm-block">mdi-forum-outline</v-icon>
          </div>
        </div>

        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-6 content-area bg-light">
            <v-row>
              
              <!-- Sidebar -->
              <v-col cols="12" md="3" class="d-flex flex-column gap-4 pr-md-4">
                
                <!-- Actions Panel -->
                <v-card class="rounded-xl border-light bg-white shadow-premium overflow-hidden" elevation="0">
                  <div class="pa-4 border-bottom">
                    <h3 class="text-subtitle-1 font-weight-bold primary-text mb-3">Acciones</h3>
                    <v-btn color="primary" block rounded class="custom-btn-shadow font-weight-bold text-none mb-3" @click="create" v-if="!foro">
                      <v-icon left>mdi-plus-circle</v-icon> Crear Nuevo Tema
                    </v-btn>
                    
                    <div v-if="foro" class="d-flex flex-column gap-2">
                      <v-btn outlined color="primary" block rounded class="text-none font-weight-bold" @click="foro = null">
                        <v-icon left>mdi-arrow-left</v-icon> Volver al listado
                      </v-btn>
                      <v-btn outlined color="info" block rounded class="text-none font-weight-bold" @click="openParticipants">
                        <v-icon left>mdi-account-group</v-icon> Ver Integrantes
                      </v-btn>
                      <v-btn outlined color="warning" block rounded class="text-none font-weight-bold" @click="editForum(idForo)" v-if="foro.alumno ? (foro.alumno_id == user.IDStB) : (foro.docente_id == user.IDStB)">
                        <v-icon left>mdi-pencil</v-icon> Editar Tema
                      </v-btn>
                      <v-btn outlined color="error" block rounded class="text-none font-weight-bold" @click="deleteForum" v-if="foro.alumno ? (foro.alumno_id == user.IDStB) : (foro.docente_id == user.IDStB)">
                        <v-icon left>mdi-delete</v-icon> Eliminar Tema
                      </v-btn>
                      <v-btn color="primary" block rounded class="custom-btn-shadow font-weight-bold text-none" @click="requestAcess()" v-if="!isParticipant()">
                        <v-icon left>mdi-lock-open</v-icon> Solicitar Acceso
                      </v-btn>
                    </div>
                  </div>
                </v-card>

                <!-- Categories Panel -->
                <v-card class="rounded-xl border-light bg-white shadow-premium overflow-hidden" elevation="0" v-if="!foro">
                  <div class="pa-4">
                    <h3 class="text-subtitle-1 font-weight-bold primary-text mb-3 d-flex align-center">
                      <v-icon color="primary" class="mr-2">mdi-shape-outline</v-icon> Secciones
                    </h3>
                    <v-list class="bg-transparent pa-0">
                      <v-list-item-group v-model="selectedCategory" color="primary">
                        <v-list-item @click="selectCategory(null)" class="rounded-lg mb-1 hover-list-item">
                          <v-list-item-icon class="mr-3">
                            <span class="category-bullet" style="background-color: #9e9e9e"></span>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-medium">Todas las secciones</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-for="(item, i) in categories" :key="i" @click="selectCategory(item)" class="rounded-lg mb-1 hover-list-item">
                          <v-list-item-icon class="mr-3">
                            <span class="category-bullet" :style="{ 'background-color': item.color }"></span>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-medium">{{ item.name }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </div>
                </v-card>

              </v-col>

              <!-- Main Content Area -->
              <v-col cols="12" md="9" class="pl-md-4 mt-6 mt-md-0 d-flex flex-column gap-4">
                
                <!-- DETAIL VIEW -->
                <template v-if="foro">
                  <v-card class="rounded-xl border-light bg-white shadow-premium overflow-hidden mb-4" elevation="0">
                    
                    <!-- Detail Header -->
                    <div class="bg-light-gradient pa-4 border-bottom d-flex align-center justify-space-between flex-wrap gap-2">
                      <div class="d-flex align-center">
                        <v-btn icon color="primary" class="mr-2 glass-btn" @click="foro = null">
                          <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                        <div>
                          <h2 class="text-h6 font-weight-bold primary-text mb-0 d-flex align-center">
                            {{ foro.title }}
                            <v-chip v-if="foro.type == 'private'" color="error" small class="ml-2 font-weight-bold" outlined>
                              <v-icon small left>mdi-lock</v-icon> Privado
                            </v-chip>
                          </h2>
                          <div class="text-caption font-weight-bold mt-1" :style="{ 'color': foro.category.color }">
                            <span class="category-bullet d-inline-block mr-1" :style="{ 'background-color': foro.category.color }"></span>
                            {{ foro.category.name }}
                          </div>
                        </div>
                      </div>
                      
                      <!-- Likes Area -->
                      <div class="d-flex align-center bg-white rounded-pill px-3 py-1 border-light">
                        <span class="font-weight-bold primary-text mr-2">{{ foro.likes }}</span>
                        <v-btn icon small color="success" @click="like" :disabled="liked">
                          <v-icon small>mdi-thumb-up</v-icon>
                        </v-btn>
                        <v-btn icon small color="error" @click="dislike" :disabled="disliked">
                          <v-icon small>mdi-thumb-down</v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <!-- Topic Content -->
                    <div class="pa-6">
                      <div class="d-flex mb-4">
                        <v-avatar size="48" class="mr-4 glass-icon-bg info-bg">
                          <v-img v-if="foro.alumno != null" :src="foro.alumno.imagen"></v-img>
                          <v-icon v-else-if="foro.profesor != null" color="primary">mdi-account-tie</v-icon>
                          <v-icon v-else color="primary">mdi-account</v-icon>
                        </v-avatar>
                        <div>
                          <h3 class="text-subtitle-1 font-weight-bold primary-text mb-0 line-height-1">
                            <span v-if="foro.alumno != null">{{ foro.alumno.Nombres }} {{ foro.alumno.Apellidos }}</span>
                            <span v-if="foro.profesor != null">{{ foro.profesor.usu_nombre }}</span>
                          </h3>
                          <span class="text-caption grey--text">{{ foro.created_at }}</span>
                        </div>
                      </div>

                      <div class="forum-content-body primary-text text-body-1 mb-6" v-html="foro.content"></div>

                      <!-- Media Carousel -->
                      <v-card class="rounded-lg overflow-hidden border-light" elevation="0" v-if="foro.images.length >= 2 || foro.video">
                        <v-carousel hide-delimiters show-arrows-on-hover height="400">
                          <v-carousel-item v-for="(image, j) in foro.images.filter(d => { return (d.status == 1) })" :key="j" :src="image.image" @click="openPublication(foro)"></v-carousel-item>
                          <v-carousel-item v-if="foro.video">
                            <video width="100%" height="400" controls class="bg-black">
                              <source :src="foro.video" type="video/mp4">
                            </video>
                          </v-carousel-item>
                        </v-carousel>
                      </v-card>
                      <v-card class="rounded-lg overflow-hidden border-light" elevation="0" v-else-if="foro.images.length == 1">
                        <v-img :src="foro.images[0].image" max-height="400" contain></v-img>
                      </v-card>
                    </div>
                  </v-card>

                  <!-- Comments Section -->
                  <h3 class="text-h6 font-weight-bold primary-text mb-4 d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-comment-multiple-outline</v-icon> Comentarios <v-chip class="ml-2 font-weight-bold" small color="primary" outlined>{{ foro.comments.length }}</v-chip>
                  </h3>

                  <!-- Comment Box -->
                  <v-card class="rounded-xl border-light bg-white shadow-premium pa-4 mb-6" elevation="0" v-if="isParticipant()">
                    <div class="d-flex">
                      <v-avatar size="48" class="mr-4 flex-shrink-0 glass-icon-bg">
                        <v-img :src="user.imagen"></v-img>
                      </v-avatar>
                      <div class="flex-grow-1">
                        <v-textarea v-model="comment" outlined rounded auto-grow rows="2" hide-details placeholder="Escribe tu comentario aquí..." class="premium-textarea mb-3"></v-textarea>
                        <div class="d-flex justify-end">
                          <v-btn color="primary" rounded class="custom-btn-shadow px-6 font-weight-bold text-none" @click="addComment()">
                            <v-icon left>mdi-send</v-icon> Enviar
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </v-card>
                  <v-alert prominent type="warning" color="warning lighten-4" class="warning--text rounded-xl font-weight-medium" v-else elevation="0">
                    Para participar en la discusión debes ser integrante. 
                    <v-btn color="warning darken-2" small rounded class="ml-2 font-weight-bold text-none" @click="requestAcess()">Solicitar acceso</v-btn>
                  </v-alert>

                  <!-- Comments Timeline -->
                  <div v-if="foro.comments.length > 0" class="comments-list">
                    <v-card v-for="(comment, j) in foro.comments" :key="j" class="rounded-xl border-light bg-white hover-card mb-4 overflow-hidden" elevation="0">
                      <div class="pa-4">
                        <div class="d-flex align-center justify-space-between mb-3">
                          <div class="d-flex align-center">
                            <v-avatar size="40" class="mr-3 glass-icon-bg">
                              <v-img v-if="comment.alumno" :src="comment.alumno.imagen"></v-img>
                              <v-icon v-else color="primary">mdi-account</v-icon>
                            </v-avatar>
                            <div>
                              <div class="font-weight-bold primary-text line-height-1 mb-1">
                                <span v-if="comment.alumno">{{ comment.alumno.Nombres }}</span>
                                <span v-if="comment.profesor">{{ comment.profesor.usu_nombre }}</span>
                              </div>
                              <div class="text-caption grey--text d-flex align-center">
                                <v-icon x-small color="grey" class="mr-1">mdi-clock-outline</v-icon> Hace {{ gettime(comment.updated_at) }}
                              </div>
                            </div>
                          </div>
                          
                          <div class="d-flex align-center gap-2">
                            <v-btn rounded small outlined color="success" class="px-2 custom-btn-shadow" @click="likeComment(comment)">
                              <span class="mr-1">{{ comment.likes }}</span> <v-icon small>mdi-thumb-up-outline</v-icon>
                            </v-btn>
                            <v-btn icon small color="error" v-if="(comment.alumno_id ? comment.alumno_id : comment.docente_id) == user.IDStB" @click="deleteComment(comment, j)">
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <div class="text-body-2 primary-text comment-body" v-html="comment.comment"></div>
                      </div>
                    </v-card>
                  </div>
                  <v-alert v-else type="info" color="info lighten-5" class="info--text rounded-xl" elevation="0">
                    <v-icon color="info" left>mdi-information</v-icon> Sé el primero en comentar y aportar al tema.
                  </v-alert>

                </template>

                <!-- LIST VIEW -->
                <template v-else>
                  <div class="d-flex align-center justify-space-between mb-4 flex-wrap">
                    <h2 class="text-h6 font-weight-bold primary-text d-flex align-center">
                      <v-icon color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
                      {{ category ? category.name : 'Todos los Temas' }}
                    </h2>
                  </div>

                  <v-alert prominent type="info" color="primary lighten-5" class="primary--text rounded-xl" v-if="items.length == 0 && show == true" elevation="0">
                    <v-icon color="primary" left>mdi-information</v-icon> No hay temas publicados {{ category ? 'en ' + category.name : 'todavía' }}.
                  </v-alert>

                  <div class="d-flex flex-column gap-3" v-else>
                    <!-- Forum Topic Cards -->
                    <v-card v-for="(item, i) in items" :key="i" class="rounded-xl border-light bg-white hover-card cursor-pointer overflow-hidden event-card" elevation="0" :style="'border-left-color: ' + item.category.color + ' !important'" @click="openForo(item.id, item)">
                      <div class="pa-4 d-flex flex-column flex-sm-row justify-space-between gap-3">
                        <div class="d-flex flex-grow-1">
                          <v-avatar size="56" class="mr-4 glass-icon-bg flex-shrink-0" :style="'background-color: ' + item.category.color + '20'">
                            <v-img v-if="item.alumno && item.alumno.imagen" :src="item.alumno.imagen"></v-img>
                            <v-icon v-else :color="item.category.color">mdi-account</v-icon>
                          </v-avatar>
                          <div>
                            <h3 class="text-subtitle-1 font-weight-bold primary-text mb-1 d-flex align-center line-height-1">
                              {{ item.title }}
                              <v-chip v-if="item.type == 'private'" color="error" x-small class="ml-2 font-weight-bold" outlined>
                                <v-icon x-small left>mdi-lock</v-icon> Privado
                              </v-chip>
                            </h3>
                            <div class="text-body-2 grey--text text--darken-1 mb-1 font-weight-medium">
                              <span v-if="item.alumno">{{ item.alumno.Nombres }} {{ item.alumno.Apellidos }}</span>
                              <span v-else-if="item.docente">{{ item.docente.usu_nombre }}</span>
                            </div>
                            <div class="text-caption d-flex align-center gap-3">
                              <span class="grey--text d-flex align-center"><v-icon x-small class="mr-1">mdi-clock-outline</v-icon>{{ item.created_at }}</span>
                              <span :style="{ 'color': item.category.color }" class="font-weight-bold">{{ item.category.name }}</span>
                            </div>
                          </div>
                        </div>
                        
                        <div class="d-flex align-center justify-sm-end gap-3 min-w-max-content">
                          <!-- Stats -->
                          <div class="d-flex flex-column align-end mr-sm-4 gap-1">
                            <v-chip small color="primary" outlined class="font-weight-bold px-2">
                              <v-icon small left>mdi-comment-text-outline</v-icon> {{ item.comments.length }}
                            </v-chip>
                            <v-chip small color="success" outlined class="font-weight-bold px-2">
                              <v-icon small left>mdi-thumb-up-outline</v-icon> {{ item.likes }}
                            </v-chip>
                          </div>
                          
                          <!-- Participants avatars -->
                          <div class="d-flex avatar-group">
                            <v-avatar size="32" class="border-white" v-for="(participant, pIdx) in item.participants.filter(d => { return (d.status == 1) }).slice(0, 4)" :key="pIdx" :color="getColor()">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-img v-if="participant.alumno && participant.alumno.imagen" v-bind="attrs" v-on="on" :src="participant.alumno.imagen"></v-img>
                                  <v-icon dark small v-bind="attrs" v-on="on" v-else>mdi-account</v-icon>
                                </template>
                                <span v-if="participant.alumno">{{ participant.alumno.Nombres }}</span>
                                <span v-else-if="participant.profesor">{{ participant.profesor.usu_nombre }}</span>
                              </v-tooltip>
                            </v-avatar>
                            <v-avatar size="32" color="grey lighten-2" class="border-white primary--text text-caption font-weight-bold" v-if="item.participants.filter(d => d.status == 1).length > 4">
                              +{{ item.participants.filter(d => d.status == 1).length - 4 }}
                            </v-avatar>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </template>

              </v-col>
            </v-row>
          </div>
        </v-card>

      </v-col>

      <!-- Dialogs -->
      <template>
        <v-dialog v-model="showForm" max-width="800px" scrollable>
          <v-card class="rounded-xl">
            <v-card-title class="bg-light-gradient border-bottom py-4 text-h6 font-weight-bold primary-text">
              <v-icon color="primary" class="mr-2">mdi-pencil-box-multiple</v-icon> {{ foro ? 'Editar tema' : 'Agregar nuevo tema' }}
            </v-card-title>
            <v-card-text class="pa-6">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="title" label="Título del tema" required outlined rounded class="premium-input"></v-text-field>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-textarea v-model.trim="content" label="Contenido del tema" type="text" hide-details outlined rounded auto-grow rows="5" class="premium-input">
                    <template slot="append">
                      <v-btn icon color="success" class="mr-1" @click="uploadFilesEvent()" title="Adjuntar imágenes"><v-icon>mdi-file-image-plus</v-icon></v-btn>
                      <v-btn icon color="warning" @click="uploadVideoEvent()" title="Adjuntar video"><v-icon>mdi-file-video-outline</v-icon></v-btn>
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-4" v-if="files.length > 0 || video">
                <v-col cols="12" class="d-flex flex-wrap gap-2">
                  <v-card v-for="(file, index) in files" :key="index" class="rounded-lg overflow-hidden border-light position-relative" width="100" height="100" elevation="0">
                    <v-img :src="file.id ? file.image : file.url" height="100%" cover></v-img>
                    <v-btn icon x-small color="error" class="position-absolute" style="top:4px; right:4px; background: rgba(255,255,255,0.8)" @click="file.id ? deleteFileThumnail(index, file.id) : deleteFileThumnail(index, null)">
                      <v-icon x-small>mdi-close</v-icon>
                    </v-btn>
                  </v-card>
                  <v-card v-if="video" class="rounded-lg border-light d-flex align-center justify-center position-relative" width="100" height="100" elevation="0" color="grey lighten-4">
                    <v-icon large color="primary">mdi-filmstrip</v-icon>
                    <v-btn icon x-small color="error" class="position-absolute" style="top:4px; right:4px; background: rgba(255,255,255,0.8)" @click="video = null">
                      <v-icon x-small>mdi-close</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="mt-4">
                <v-col cols="12" md="6">
                  <v-select v-model="formCategory" :items="categories" item-text="name" item-value="id" label="Sección" outlined rounded class="premium-input" return-object hide-details></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select v-model="formType" :items="types" item-text="name" item-value="id" label="Visibilidad" outlined rounded class="premium-input" return-object hide-details></v-select>
                </v-col>
              </v-row>
              <input type="file" @change="onFileChange" ref="fileInput" style="display: none;" multiple accept="image/*" />
              <input type="file" @change="onVideoChange" ref="fileInputVideo" style="display: none;" accept="video/*" />
            </v-card-text>
            <v-card-actions class="pa-4 bg-light-gradient border-top">
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" text rounded class="text-none font-weight-bold px-4 mr-2" @click="showForm = false">Cancelar</v-btn>
              <v-btn color="primary" rounded class="custom-btn-shadow text-none font-weight-bold px-6" @click="addForum">Guardar Tema</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Participants Dialog -->
        <v-dialog v-model="showParticipants" max-width="600px" scrollable v-if="foro">
          <v-card class="rounded-xl">
            <v-card-title class="bg-light-gradient border-bottom py-4 text-h6 font-weight-bold primary-text">
              <v-icon color="primary" class="mr-2">mdi-account-group</v-icon> Participantes del foro
            </v-card-title>
            <v-card-text class="pa-0" style="height: 400px;">
              <v-list class="bg-transparent pa-2">
                <div v-for="(participant, $index) in list" :key="$index">
                  <v-list-item v-if="participant.status == 1 || (foro.alumno_id == user.IDStB && participant.status > 0)" class="rounded-lg mb-2 border-light hover-card" :class="participant.status == 2 ? 'bg-warning-light' : 'bg-white'">
                    <v-list-item-avatar color="primary lighten-4" @click="openProfile(participant.alumno.IDStB)" class="cursor-pointer">
                      <v-img :src="participant.alumno.imagen" v-if="participant.alumno"></v-img>
                      <v-icon color="primary" v-else>mdi-account</v-icon>
                    </v-list-item-avatar>
                    
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold primary-text">
                        <span v-if="participant.alumno">{{ participant.alumno.Nombres + ' ' + participant.alumno.Apellidos }}</span>
                        <span v-if="participant.profesor">{{ participant.profesor.usu_nombre }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="participant.administrator">
                        <v-chip x-small color="success" outlined class="font-weight-bold mt-1">Administrador</v-chip>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    
                    <v-list-item-action class="d-flex flex-row gap-1" v-if="isAdministrator() && user.IDStB !== (participant.alumno ? participant.alumno_id : participant.docente_id)">
                      <v-btn @click="deleteParticipant(participant)" icon small color="error" title="Eliminar integrante" v-if="participant.status == 1">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                      <template v-if="participant.status == 2">
                        <v-btn @click="accept(participant)" icon small color="success" title="Aceptar solicitud" class="mr-1">
                          <v-icon small>mdi-check</v-icon>
                        </v-btn>
                        <v-btn @click="rejectParticipant(participant)" icon small color="error" title="Rechazar solicitud">
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </template>
                    </v-list-item-action>
                  </v-list-item>
                </div>
                <infinite-loading @infinite="infiniteHandler" ref="InfiniteLoading">
                  <span slot="no-more"></span>
                </infinite-loading>
              </v-list>
            </v-card-text>
            <v-card-actions class="pa-4 bg-light-gradient border-top">
              <v-btn color="error" text rounded class="text-none font-weight-bold px-4" @click="leaveForum()" v-if="(foro.alumno_id ? foro.alumno_id : foro.docente_id) !== user.IDStB && isParticipant()">
                <v-icon left>mdi-exit-to-app</v-icon> Salir del foro
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" rounded class="custom-btn-shadow text-none font-weight-bold px-6" @click="closeParticipants()">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";
import InfiniteLoading from 'vue-infinite-loading';
moment.locale('es')

export default {
    name: "Foro",
    components: {
        // CardIeaApp,
        CardIeaAppMain,
        InfiniteLoading,
    },

    data: () => ({
        categories: [],
        selectedCategory: 0,
        items: [],
        category: null,
        showForm: false,
        formCategory: null,
        formType: null,
        cursos: [],
        curso: '',
        formCourse: null,
        title: '',
        content: '',
        types: [
            { id: 'public', name: 'Público' },
            { id: 'private', name: 'Privado' },
        ],
        video: null,
        selecteds: [],
        files: [],
        limit: 10,
        foro: null,
        comment: '',
        liked: false,
        disliked: false,
        showParticipants: false,
        parts: [],
        participants: [],
        idForo: '',

        idParticipants: null,
        page: 1,
        list: [],
        par: [],
        idForoData: null,
        selctForo: null,
        show: false,
        showCategoria: false,
        nombreCategoria: ''
    }),
 
    mounted() {
        if (this.$store.getters.user.borrado == 1 || this.$store.getters.user.alumno_mora == true || this.$store.getters.user.excedente) {
            this.$router.push({
                name: "Home"
            });
        }
        this.getCategories();
        this.getForums();
        this.getMateria();
    },

    computed: {
        user() {
            return this.$store.getters.user;
        },
    },

    methods: {
        closeParticipants() {
            this.showParticipants = false
            this.$refs.InfiniteLoading.stateChanger.reset();
        },

        infiniteHandler($state) {
            this.$API
                .get({
                    url: "participants-forum/" + this.idParticipants + "?page=" + this.page,
                }).then(({ data }) => {
                    if (data.length) {
                        this.page += 1;
                        this.list.push(...data)
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                });
            console.log(this.list, 'soy list')
        },

        async getParts() {
            await this.$API
                .get({
                    url: "participants-forum/" + this.idParticipants + "?page=1",
                    data: {}
                })
                .then((res) => {
                    let dato = res;
                    this.parts = dato.data;
                    console.log(this.parts)
                });
        },
        async getMateria() {
            await this.$API
                .get({
                    url: "materia-codigo",
                    data: {}
                })
                .then(res => {

                    let dato = res.data;
                    this.cursos = dato;
                    console.log(this.types, this.cursos)
                });
        },
        create() {
            this.showForm = true
            this.foro = null
        },
        createCategoria() {
            this.showCategoria = true
            this.foro = null
            this.showForm = false
        },
        gettime(date_publish) {
            let current_date = moment();
            let published_date = moment(date_publish);
            return (moment.duration(current_date - published_date).humanize())
        },
        deleteFileThumnail(index, id) {
            this.files.splice(index, 1);
            if (id) {
                this.images_deleted.push(id)
                console.log(this.images_deleted)
            }
        },
        async uploadFilesEvent() {
            this.$refs.fileInput.click()
        },
        onFileChange(e) {
            let all = e.target.files;
            let r = this.files;
            [all].forEach((val) => {
                if (r.length < this.limit) {
                    for (const item of val) {
                        if (item.type.match('image.*')) {
                            item.url = URL.createObjectURL(item);
                            r.push(item);
                        }
                    }
                }
            });
            this.files = Array.from(r);
            if (this.limit < this.files.length) {
                alert('El número máximo de imágenes por publicación es ' + this.limit);
                this.files.splice(this.limit, (this.files.length - this.limit))
            }
        },
        onVideoChange(e) {
            let v = e.target.files[0];
            if (v.type.match('video.*')) {
                this.video = v;
            } else {
                alert('Agrega un formato válido de video')
            }
        },
        async getCategories() {

            let categoria_id = this.$route.params.categoria_id

            await this.$API
                .get({
                    url: "forum-categories",
                    data: {}
                })
                .then(e => {
                    e.forEach(element => {
                        this.categories.push(element)
                        if(element.id==categoria_id){
                            this.category=element
                        }
                    });
                    console.log(this.categories)
                    // this.categories.forEach(cat => {
                    //     console.log("esetoo", cat.id, categoria_id)
                    //     if (cat.id == categoria_id) {
                    //         this.category = cat
                    //     }
                    // })
                });
        },

        async getForums(category = null) {
            let categoria_id = this.$route.params.categoria_id
            console.log("esta es la categoria", categoria_id)
            let url = 'forums-by-category/' + categoria_id;
            if (category) {
                this.$router.push({
                    name: "ForoCategoria",
                    params: { categoria_id: category.id }
                });
            }
            console.log("estas son las categorias", this.categories)
            await this.$API
                .get({
                    url: url,
                    data: {}
                })
                .then(res => {
                    this.items = res.data;
                    this.show = true;
                    console.log(this.items)
                });
        },

        async getForumsAll() {
            let url = 'forums';
            await this.$API
                .get({
                    url: url,
                    data: {}
                })
                .then(res => {
                    this.items = res.data;
                    this.show = true;
                    console.log(this.items)
                });
        },

        async selectCategory(cat = null) {
            if (cat !== null) {
                this.category = cat;
                this.getForums(cat)
                this.foro = null;
            } else {
                this.category = null;
                this.getForumsAll();
                this.foro = null;
            }
        },
        async openForo(id, selctForo) {
            this.list.length = 0
            this.page = 1
            this.comment = '';
            this.idParticipants = id;
            // this.idForoData = id;
            this.selctForo = selctForo;
            this.par = selctForo.participants;
            this.idForo = id;
            console.log(selctForo)
            let canView = true;
            if (selctForo.type == 'private') {
                let e = selctForo.participants.findIndex(d => { return (d.alumno_id == this.user.IDStB && d.status == 1) });
                if (e == -1) {
                    canView = false;
                    if (confirm('¿Este es un foro privado, te gustaría ser solicitar acceso?')) {
                        this.requestAcess(id);
                    }
                }
            }

            if (canView) {
                this.foro = selctForo
                /*this.$router.push({
                  name: "ForoDetalle",
                  params: {
                    id: id,
                    foro:foro
                  }
                });
                */
            }
        },
        editForum(id) {
            this.parts = [];
            this.getParts(id)
            this.showForm = true;
            this.title = this.foro.title
            this.formCategory = this.foro.category
            this.formType = this.foro.type
            this.content = this.foro.content
            this.files = this.foro.images;
            this.video = this.foro.video;
        },
        getColor() {
            let colors = ['#a7ba38', '#095da1', '#e79029', '#dd404a', '#8fc6dc'];
            let min = 0;
            var max = colors.length;
            var random = Math.floor(Math.random() * (max - min)) + min;
            return colors[random];
        },
        async addForum() {
            if (this.content && this.title && this.formCategory && this.formType) {
                var formData = new FormData();
                formData.append('title', this.title);
                formData.append('forum_category_id', this.formCategory.id);
                formData.append('type', this.formType.id);
                formData.append('content', this.content);

                if (this.files.length > 0) {
                    formData.append('cantidadImagen', this.files.length);
                    let i = 0;
                    for (let file of this.files) {
                        formData.append(`imagen_${i}`, file, file.name);
                        i++;

                    }
                }

                if (this.files.length > 0) {
                    formData.append('cantidadImagen', this.files.length);
                    let i = 0;
                    for (let file of this.files) {
                        formData.append(`imagen_${i}`, file, file.name);
                        i++;

                    }
                }

                if (this.video) {
                    formData.append('video', this.video);
                }

                if (this.selecteds.length > 0) {
                    let taggeds = new Array();
                    this.selecteds.forEach((val) => {
                        if (this.content.includes(val.value)) {
                            taggeds.push(val.id);
                        }
                    });
                    formData.append('tagged', taggeds.join(','));
                }

                formData.append('cod', this.curso.cod);
                console.log(formData);
                let url = this.foro ? 'forums/' + this.foro.id : 'forums'
                await this.$API
                    .post({
                        url: url,
                        data: formData
                    }).then(res => {
                        console.log(res)
                        this.foro = res;
                        this.items.unshift(res);
                        this.idParticipants = res.id
                        this.title = '';
                        this.content = '';
                        this.files = [];
                        this.video = null;
                        this.showForm = false;
                        this.par = res.participants
                    });
            } else {
                alert('Completa todos los campos')
            }
        },
        async addCategoria() {
            console.log(this.nombreCategoria.trim().length)
            if (this.nombreCategoria.trim().length > 0) {
                var formData = new FormData();
                formData.append('name', this.nombreCategoria.trim());
                let url = 'forum/add-categoria'
                await this.$API
                    .post({
                        url: url,
                        data: formData
                    }).then(res => {
                        console.log(res)

                        this.showCategoria = false
                        this.getCategories()
                    });
            } else {
                alert('Completa todos los campos')
            }
        },
        async addComment() {
            if (this.comment) {
                var formData = new FormData();
                formData.append('comment', this.comment);
                formData.append('taged', '');
                await this.$API
                    .post({
                        url: "forums-comment/" + this.foro.id,
                        data: formData
                    }).then(res => {
                        console.log(res)
                        res.likes = 0;
                        this.foro.comments.unshift(res);
                        this.comment = '';
                    });
            } else {
                alert('Escribe primero tu comentario')
            }
        },
        async like() {
            await this.$API
                .post({
                    url: "forums-like/" + this.foro.id,
                    data: {}
                }).then(res => {
                    if (res) {
                        this.foro.likes++;
                        this.liked = true;
                    }
                });
        },
        async likeComment(comment) {
            await this.$API
                .post({
                    url: "forums-comment-like/" + comment.id,
                    data: {}
                }).then(res => {
                    if (res) {
                        comment.likes++;
                    }
                });
        },
        async dislike() {
            await this.$API
                .delete({
                    url: "forums-like/" + this.foro.id,
                    data: {}
                }).then(res => {
                    if (res) {
                        this.foro.likes--;
                        this.disliked = true;
                    }
                });
        },
        async uploadVideoEvent() {
            this.$refs.fileInputVideo.click()
        },
        async deleteComment(comment, j) {
            if (confirm('¿Estas seguro de querer eliminar este comentario?')) {
                await this.$API
                    .delete({
                        url: "forums-comment/" + comment.id,
                        data: {}
                    }).then(res => {
                        if (res) {
                            this.foro.comments.splice(j, 1)
                        }
                    });
            }
        },
        async deleteForum() {
            if (confirm('¿Estas seguro de querer eliminar este tema?')) {
                await this.$API
                    .delete({
                        url: "forums/" + this.foro.id,
                        data: {}
                    }).then(res => {
                        if (res) {
                            this.foro = null
                            this.getForums(this.category);
                        }
                    });
            }
        },
        openParticipants() {
            this.showParticipants = true;
        },
        isAdministrator() {
            return (this.par.filter(d => { return ((d.alumno_id ? d.alumno_id : d.docente_id) == this.user.IDStB && d.administrator == 1) }).length > 0) ? true : false
        },
        isParticipant() {
            return (this.par.filter(d => { return ((d.alumno_id ? d.alumno_id : d.docente_id) == this.user.IDStB && d.status == 1) }).length > 0) ? true : false
        },
        async leaveForum() {
            if (confirm('¿Estas seguro de querer salirte de este foro?')) {
                await this.$API
                    .post({
                        url: "forums/leave/" + this.foro.id,
                    }).then(res => {
                        if (res == true) {
                            this.foro = null;
                            this.getForums(this.category);
                        }
                    });
            }
        },
        async requestAcess(id = null) {
            let foroId = id ? id : this.foro.id;
            await this.$API
                .post({
                    url: "forums/access/" + foroId,
                }).then(res => {
                    if (res == true) {
                        alert('Tu solicitud ha sido enviada')
                    }
                });
        },
        async accept(participant) {
            await this.$API
                .post({
                    url: "forums/accept/" + participant.id,
                }).then(res => {
                    if (res == true) {
                        alert('Integrante aceptado')
                        participant.status = 1;
                    }
                });
        },
        async deleteParticipant(participant) {
            await this.$API
                .delete({
                    url: "forum-participant/" + participant.id,
                }).then(res => {
                    if (res == true) {
                        alert('Integrante eliminado')
                        participant.status = 0;
                    }
                });
        },
        async rejectParticipant(participant) {
            await this.$API
                .post({
                    url: "forums/reject/" + participant.id,
                }).then(res => {
                    if (res == true) {
                        alert('Integrante rechazado')
                        participant.status = 0;
                    }
                });
        }
    }
}
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.foro-container { background: transparent !important; min-height: calc(100vh - 120px); }
.glass-panel { background: rgba(255, 255, 255, 0.7) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.5) !important; box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important; border-radius: 20px; padding: 24px; }
.glass-card { background: rgba(255, 255, 255, 0.85) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.4) !important; }
.glass-btn { background: rgba(25, 118, 210, 0.1) !important; backdrop-filter: blur(4px) !important; box-shadow: none !important; transition: all 0.3s ease; }
.glass-btn:hover { background: rgba(25, 118, 210, 0.2) !important; transform: translateY(-2px); }
.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }
.bg-warning-light { background-color: #fff8e1 !important; }
.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-bottom { border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-top { border-top: 1px solid rgba(0, 0, 0, 0.05) !important; }
.hover-card { transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); }
.hover-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.12) !important; }
.shadow-premium { box-shadow: 0 10px 30px -10px rgba(0,0,0,0.08) !important; }
.custom-btn-shadow { box-shadow: 0 8px 20px -6px rgba(25, 118, 210, 0.4) !important; transition: all 0.3s ease; }
.custom-btn-shadow:hover { transform: translateY(-2px); box-shadow: 0 12px 25px -6px rgba(25, 118, 210, 0.5) !important; }

/* Utilities */
.gap-1 { gap: 4px; }
.gap-2 { gap: 8px; }
.gap-3 { gap: 12px; }
.gap-4 { gap: 20px; }
.line-height-1 { line-height: 1.2; }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
.cursor-pointer { cursor: pointer; }
.position-relative { position: relative; }
.position-absolute { position: absolute; }
.min-w-max-content { min-width: max-content; }

/* Custom elements */
.glass-icon-bg { border-radius: 12px; display: flex; align-items: center; justify-content: center; background: rgba(25, 118, 210, 0.08); }
.info-bg { background: rgba(3, 169, 244, 0.1); }
.category-bullet { width: 12px; height: 12px; border-radius: 50%; display: inline-block; box-shadow: inset 0 2px 4px rgba(0,0,0,0.1); }
.hover-list-item:hover { background-color: rgba(25, 118, 210, 0.05); }

/* Avatar grouping */
.avatar-group { display: flex; }
.avatar-group .v-avatar { margin-left: -8px; border: 2px solid white !important; transition: transform 0.2s; }
.avatar-group .v-avatar:first-child { margin-left: 0; }
.avatar-group .v-avatar:hover { transform: translateY(-2px); z-index: 10; }

.premium-textarea :deep(.v-input__slot) { background-color: #f8fafc !important; }
.premium-input :deep(.v-input__slot) { background-color: #f8fafc !important; }
.event-card { border-left-style: solid !important; border-left-width: 4px !important; }
</style>